if (!customElements.get('product-recommender')) {
  customElements.define('product-recommender', class ProductRecommender extends HTMLElement {
    constructor() {
      super();
      this.cards = [];
      this.panels = [];
      this.cardsSlider = null;
      this.handleCardClick = this.handleCardClick.bind(this);
      this.handleCardKeydown = this.handleCardKeydown.bind(this);
    }

    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.product-recommender__card'));
      this.panels = Array.from(this.querySelectorAll('.product-recommender__expanded'));
      this.cardsSlider = this.querySelector('.product-recommender__cards-slider');

      this.cards.forEach(card => {
        card.addEventListener('click', this.handleCardClick);
        card.addEventListener('keydown', this.handleCardKeydown);
      });
    }

    disconnectedCallback() {
      this.cards.forEach(card => {
        card.removeEventListener('click', this.handleCardClick);
        card.removeEventListener('keydown', this.handleCardKeydown);
      });
    }

    handleCardClick(e) {
      const index = e.currentTarget.dataset.index;
      this.togglePanel(index);
    }

    handleCardKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const index = e.currentTarget.dataset.index;
        this.togglePanel(index);
      }
    }

    closeAllPanels() {
      this.cards.forEach(card => card.setAttribute('aria-expanded', 'false'));
      this.panels.forEach(panel => {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });
    }

    openPanel(index) {
      const card = this.querySelector(`[data-index="${index}"]`);
      const blockId = card && card.dataset.blockId;
      const panel = blockId ? this.querySelector(`.product-recommender__expanded[data-block-id="${blockId}"]`) : null;

      if (panel && card) {
        card.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-active');
        panel.hidden = false;

        if (this.cardsSlider && typeof this.cardsSlider.navigateToSlide === 'function') {
          this.cardsSlider.navigateToSlide(parseInt(index), true);
        }

        setTimeout(() => {
          panel.querySelectorAll('component-slider').forEach(slider => {
            if (typeof slider.setUpSlider === 'function') slider.setUpSlider();
          });
          panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 50);
      }
    }

    togglePanel(index) {
      const card = this.querySelector(`[data-index="${index}"]`);
      const isExpanded = card.getAttribute('aria-expanded') === 'true';

      this.closeAllPanels();

      if (!isExpanded) {
        this.openPanel(index);
      }
    }
  });
}
